const SVGComponent = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5791 3.50849C11.2902 2.44714 10.3196 1.66675 9.16667 1.66675C7.78595 1.66675 6.66667 2.78604 6.66667 4.16675C6.66667 5.54746 7.78595 6.66675 9.16667 6.66675C9.49187 6.66675 9.80258 6.60465 10.0876 6.49167M11.5791 3.50849C11.8641 3.39551 12.1748 3.33341 12.5 3.33341C13.8807 3.33341 15 4.4527 15 5.83341C15 7.21413 13.8807 8.33341 12.5 8.33341C11.3471 8.33341 10.3765 7.55302 10.0876 6.49167M11.5791 3.50849C10.4098 3.97205 9.75956 5.28675 10.0876 6.49167M5.83333 16.6667H7.5C7.5 16.6667 9.49304 17.4363 10.8333 17.5001C13.7886 17.6408 16.1361 16.266 18.0375 14.1749C18.4717 13.6974 18.4644 12.9764 18.0612 12.4724C17.5414 11.8227 16.5645 11.7701 15.9127 12.2874C15.1946 12.8573 14.2415 13.4983 13.3333 13.7501C12.0789 14.0978 10.8333 14.1667 10.8333 14.1667C17.5 13.7501 15 8.33329 5.83333 12.0835M4.16667 17.5001C3.24619 17.5001 2.5 16.7539 2.5 15.8334V12.5001C2.5 11.5796 3.24619 10.8334 4.16667 10.8334C5.08714 10.8334 5.83333 11.5796 5.83333 12.5001V15.8334C5.83333 16.7539 5.08714 17.5001 4.16667 17.5001Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinejoin="round"
    />
  </svg>
)
export default SVGComponent
